import { render, staticRenderFns } from "./EditUserProfile.vue?vue&type=template&id=05b0f150"
import script from "./EditUserProfile.vue?vue&type=script&lang=js"
export * from "./EditUserProfile.vue?vue&type=script&lang=js"
import style0 from "./EditUserProfile.vue?vue&type=style&index=0&id=05b0f150&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports